import { LocationInfo, selectUserLocation } from "../../redux/features/location/slice";
import { useAppSelector } from "../../redux/hooks";
import MapElementProps from "./MapElementProps";
import { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";

const UserLocationMarker = ({map}: MapElementProps) => {
    const userLocation: LocationInfo | undefined = useAppSelector(selectUserLocation);
    const [marker, setMarker] = useState<mapboxgl.Marker | undefined>();
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (map && ref.current) {
            setMarker(new mapboxgl.Marker(ref.current!, {
                anchor: 'center',
            }));
        }
    }, [map, ref.current]);

    useEffect(() => {
        if (marker && userLocation && userLocation.coordinate) {
            marker.setLngLat([userLocation.coordinate.longitude, userLocation.coordinate.latitude]);
            marker.addTo(map!);
        }
    }, [userLocation, marker]);

    if (!map) {
        return <></>;
    }

    return (
        <div ref={ref}>
            <div style={{
                width: 14,
                height: 14,
                borderRadius: '50%',
                backgroundColor: '#4a90e2',
                border: '2px solid #ffffff',
                boxShadow: '0 1px 4px rgba(0,0,0,0.4)',
            }} />
        </div>
    );
};

export default UserLocationMarker;
